import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { CustomDomainResponse } from '../models/responses/custom-domain-response';
import { CustomDomainStatusResponse } from '../models/responses/custom-domain-status';

@Injectable({
  providedIn: 'root'
})
export class CustomDomainService {

  constructor(private httpClient:HttpClient) { }
  
  public createDomain(domain:string){
    return this.httpClient.post<CustomDomainResponse>(`${environment.customDomainUrl}`,{domain:domain})
  }

  public fetchStatus(id:number){
    return this.httpClient.get<CustomDomainStatusResponse>(`${environment.customDomainUrl}/status/${id}`)
  }

  public fetchDomainStatusForLoggedUser(){
    return this.httpClient.get<CustomDomainStatusResponse>(`${environment.customDomainUrl}/status`)
  }

  public fetch(id:number){
    return this.httpClient.get<CustomDomainResponse>(`${environment.customDomainUrl}/${id}`)
  }

  public fetchForLoggedUser(){
    return this.httpClient.get<CustomDomainResponse>(`${environment.customDomainUrl}`)
  }

  public delete(id:number){
    return this.httpClient.delete<CustomDomainResponse>(`${environment.customDomainUrl}/${id}`)
  }
}
